import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { map } from 'rxjs';

import { SystemUserProfileResponse } from '../models/system-user.interface';
import { toSystemUserProfile } from '../helpers/system-users-adapter.functions';
import { API_URL } from '../tokens/api.tokens';

@Injectable({ providedIn: 'root' })
export class SystemUsersService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl: string;

  constructor(@Inject(API_URL) apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  getAll() {
    return this.http
      .get<SystemUserProfileResponse[]>(`${this.apiUrl}/profile/all`)
      .pipe(map(responses => responses.map(toSystemUserProfile)));
  }
}
